import PropTypes from "prop-types";
import Loader from "shared/components/Loader";
import { useQuery } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { INITIAL_VALUES } from "../utils/constants";

const ProductRanges = ({ View, filter, ...props }) => {
  const variables = {
    ...filter,
    skip: parseInt(filter.skip) ?? INITIAL_VALUES.skip,
    take: parseInt(filter.take) ?? INITIAL_VALUES.take,
  };
  const query = useQuery(graphql.queries.PRODUCT_RANGES, {
    variables,
  });
  const WrappedView = Loader(View);
  return (
    <WrappedView
      {...{
        ...props,
        ...query,
        type: "productRanges",
      }}
    />
  );
};

ProductRanges.propTypes = {
  View: PropTypes.func.isRequired,
  filter: PropTypes.object,
};

ProductRanges.defaultProps = {
  filter: {},
};

export default ProductRanges;
